import { URL_REPLACEMENT } from '$const';
import { remove } from '~services/api/methods';

export async function removeChangelogItem(id: ChangelogItem['id']) {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/api/ebm/changelog/items/${id}`;
  const response = await remove<boolean>(requestUrl);
  return response;
}
